import React, { useState, useEffect } from "react";
import "./chat.css";
import { useSelector } from "react-redux";
import man from "../../../bgimage/man.png";
import man2 from "../../../bgimage/chatman.png";
import socket from "../../../services/socket";
import axios from "axios";
import { genrateTicketdata, URLApi } from "../../../services/api_function";
import toast from "react-hot-toast";

const Chat = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const [typedMessage, setTypedMessage] = useState({});
  const [ticketData, setTicketData] = useState([]);
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const fetchTickets = async () => {
    try {
      const data = await genrateTicketdata();
      console.log(data?.tickets, "this is the ticket dat");
      setTicketData(data?.tickets || []);
      data?.forEach((ticket) => {
        socket.emit("join_ticket", ticket.ticketId);
      });
    } catch (error) {
      console.error("Error fetching tickets:", error);
    }
  };

  useEffect(() => {
    fetchTickets();

    socket.on("receive_message", ({ ticketId, message }) => {
      console.log(ticketId, "there is any ticket id");
      setTicketData((prevData) =>
        prevData.map((ticket) =>
          ticket.ticketId === ticketId
            ? {
                ...ticket,
                messages: [...(ticket.messages || []), message],
                updatedAt: new Date().toISOString(),
              }
            : ticket
        )
      );
    });

    return () => {
      socket.off("receive_message");
    };
  }, []);

  const handleSendMessage = async (msg, id) => {
    if (!msg?.trim()) {
      toast.error("Please enter a message!");
      return;
    }

    try {
      const res = await axios.post(`${URLApi}/ticketsmsg`, {
        ticketId: id,
        sender: "Admin",
        message: msg,
      });

      if (res?.data?.ticketId && res?.data?.messages) {
        const newMessage = {
          sender: "Admin",
          message: msg,
          timestamp: new Date().toISOString(),
        };

        socket.emit("send_message", {
          ticketId: "YLNKW229290",
          message: newMessage,
        });

        setTicketData((prevData) =>
          prevData.map((ticket) =>
            ticket.ticketId === id
              ? {
                  ...ticket,
                  messages: [...(ticket.messages || []), newMessage],
                  updatedAt: newMessage.timestamp,
                }
              : ticket
          )
        );

        setTypedMessage((prev) => ({ ...prev, [id]: "" }));
      } else {
        toast.error("Error sending message!");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error sending message!");
    }
  };

  return (
    <div className="chat-container">
      <main className="pt-3 support_main w-100 overflow-auto">
        <div className="container-fluid">
          {ticketData?.map((ticket, index) => (
            <div
              className="accordion accordion-flush mb-3"
              id={`accordion-${index}`}
              key={ticket._id}
            >
              <div className="accordion-item rounded">
                <h2 className="accordion-header" id={`flush-heading-${index}`}>
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#flush-collapse-${index}`}
                    aria-expanded="false"
                    aria-controls={`flush-collapse-${index}`}
                    style={{
                      background: "linear-gradient(to right, #093637, #44A08D)",
                      borderRadius: "10px",
                    }}
                  >
                    <div className="card-body p-0 overflow-x-auto w-100">
                      <div className="d-flex gap-4 flex-wrap text-white">
                        <div>
                          <div
                            className="fs-10"
                            style={{ color: "rgb(67 243 114)" }}
                          >
                            Id No.
                          </div>
                          {ticket.ticketId || "No ID"}
                        </div>
                        <div>
                          <div
                            className="fs-10"
                            style={{ color: "rgb(67 243 114)" }}
                          >
                            Subject
                          </div>
                          {ticket.subject || "No Subject"}
                        </div>
                        <div>
                          <div
                            className="fs-10"
                            style={{ color: "rgb(67 243 114)" }}
                          >
                            Last Update
                          </div>
                          {new Date(
                            ticket.updatedAt || ticket.createdAt
                          ).toLocaleString()}
                        </div>
                        <div>
                          <div
                            className="fs-10"
                            style={{ color: "rgb(67 243 114)" }}
                          >
                            Status
                          </div>
                          <span className="badge rounded-pill text-bg-success">
                            {ticket.status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </button>
                </h2>
                <div
                  id={`flush-collapse-${index}`}
                  className="accordion-collapse collapse"
                  aria-labelledby={`flush-heading-${index}`}
                  data-bs-parent={`#accordion-${index}`}
                >
                  <div className="accordion-body">
                    <div
                      style={{
                        maxHeight: "400px",
                        overflowY: "scroll",
                        overflowX: "hidden",
                      }}
                      className="chat_custom-scrollbar px-3"
                    >
                      {ticket?.messages?.map((msg, idx) => {
                        const isAdmin = msg.sender === "Admin";
                        const senderName = isAdmin ? "Admin" : ticket.username;
                        return (
                          <div
                            key={idx}
                            className={`row mb-2 ${
                              isAdmin ? "" : "justify-content-end"
                            }`}
                          >
                            <div className="col-lg-6 col-sm-12">
                              <div
                                className={`d-flex gap-2 ${
                                  isAdmin ? "" : "justify-content-end"
                                }`}
                              >
                                {!isAdmin && (
                                  <img
                                    src={man}
                                    alt="user"
                                    className="rounded-circle"
                                    style={{ height: 40, width: 40 }}
                                  />
                                )}
                                <div
                                  className={`card mb-2 shadow-none border ${
                                    isAdmin
                                      ? "border-warning bg-warning-transparent"
                                      : "border-secondary bg-secondary-transparent"
                                  }`}
                                  style={{
                                    borderRadius: "10px",
                                    maxWidth: "100%",
                                  }}
                                >
                                  <div className="card-body py-3">
                                    <h6 className="mb-0 text-info">
                                      {senderName}
                                    </h6>
                                    <div className="text-dark">
                                      {msg.message}
                                    </div>
                                  </div>
                                </div>
                                {isAdmin && (
                                  <img
                                    src={man2}
                                    alt="admin"
                                    className="rounded-circle"
                                    style={{ height: 40, width: 40 }}
                                  />
                                )}
                              </div>
                              <div
                                className={`fs-12 ${
                                  isAdmin ? "ms-5" : "text-end"
                                } mb-3`}
                              >
                                <span className="text_gray">
                                  {new Date(msg.timestamp).toLocaleString(
                                    "en-IN",
                                    {
                                      hour: "numeric",
                                      minute: "numeric",
                                      hour12: true,
                                      day: "numeric",
                                      month: "short",
                                      year: "numeric",
                                    }
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    {/* Send message input */}
                    <div className="col-lg-12 rounded-3 d-flex justify-content-between align-items-end p-3 gap-3 bg-warning-transparent border border-warning shadow-sm mt-3">
                      <div className="flex-grow-1">
                        <label
                          htmlFor={`message-${index}`}
                          className="form-label fw-semibold text-dark"
                        >
                          Message
                        </label>
                        <textarea
                          className="form-control"
                          id={`message-${index}`}
                          rows="2"
                          placeholder="Enter your message..."
                          style={{ resize: "none", borderRadius: "0.5rem" }}
                          value={typedMessage[ticket.ticketId] || ""}
                          onChange={(e) => {
                            const msg = e.target.value.slice(0, 500);
                            setTypedMessage((prev) => ({
                              ...prev,
                              [ticket.ticketId]: msg,
                            }));
                          }}
                        />
                      </div>
                      <button
                        className="btn text-white"
                        style={{
                          background:
                            "linear-gradient(to right, #093637, #44A08D)",
                          height: "40px",
                          width: "100px",
                          borderRadius: "0.5rem",
                        }}
                        onClick={() =>
                          handleSendMessage(
                            typedMessage[ticket.ticketId],
                            ticket.ticketId
                          )
                        }
                      >
                        <i className="bi bi-send me-2"></i>Send
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Chat;
